module.exports = {
  styles: {
    namespace: "tr"
  }
};
